import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import { isV2 } from "../lib/config";

export type StaffRoleName = "cashier" | "manager" | "admin" | "owner";
export interface StaffMember {
  id: string; name: string; username: string; role: StaffRoleName; active: boolean; locale: "ar" | "en"; hasManagerPin: boolean; badgeUid: string | null; createdAt: string;
  /** null = the default of the role */
  permissions: string[] | null; effective: string[]; custom: boolean;
  branches: Array<{ branchId: string; role: StaffRoleName; canApproveOverrides: boolean }>;
}
export interface StaffView { staff: StaffMember[]; branches: Array<{ id: string; code: string; name: string; name_ar: string | null }>; me: { id: string; role: StaffRoleName }; permissions: string[] }

export const staffKey = ["staff"] as const;
export const useStaff = (enabled = true) => useQuery({ queryKey: staffKey, enabled: enabled && isV2(), queryFn: () => api.get<StaffView>("/staff") });
export function useRefreshStaff() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: staffKey });
}
